export default {
    p: {
        uo: {
            kpi: {
                totalUsers: '注册总数',
                newUsers7d: '近7天新增',
                newUsers30d: '近30天新增',
                creatorCount: '创作者数',
                creatorDesc: '发布过内容单元的用户 ÷ 注册用户',
                launcherCount: '发射者数',
                launcherDesc: '发射过代币的用户 ÷ 注册用户',
                ratio: '占比',
                dau: 'DAU（最新日）',
                dauAvg30d: '近 30 日均 {value}',
                wau: '最新 WAU',
                wauDesc: '自然周去重活跃',
                mau: '最新 MAU',
                mauDesc: '自然月去重活跃',
                avgOnline: '人均在线时长',
                avgOnlineDesc: '总时长 ÷ 当日活跃用户',
                avgActive: '人均活跃次数',
                avgActiveDesc: '访问 gateway 次数 ÷ 日活用户',
            },
            duration: {
                h: '小时',
                m: '分',
                s: '秒',
            },
            summary: {
                dataAsOf: '数据截至',
                utcNote: 'UTC 业务日口径',
            },
            trend: {
                title: '活跃趋势',
                dau: 'DAU 日活',
                wau: 'WAU 周活',
                mau: 'MAU 月活',
                start: '开始日期',
                end: '结束日期',
            },
        },
    },
};
